/**
 * @ignore
 * Created by daletan on 8/25/16.
 */

'use strict';

const get = require('lodash.get');
const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');

// Stores
const ItemStore = require('../../stores/ItemStore.es');
const UserStore = require('../../../global/stores/UserStore.es');
const PriceStore = require('../../../global/stores/PriceStore.es.js');
const TourStore = require('../../../components/Tour/TourStore.es');

const { OPEN_DETAILS_FROM_DESCRIPTION } = require('../../constants/shippingConstants.es');

// Components
const Tour = require('../../../components/Tour/Tour');
const QuotePrimary = require('./QuotePrimary');
const QuoteHandling = require('./QuoteHandling');
const QuoteSecondary = require('./QuoteSecondary');
const ShippingDetailsLink = require('./ShippingDetailsLink');

// Helpers
const { filterQuotes } = require('./shippingHelpers.es');
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const tourTracking = require('../../../global/tracking/tourTracking.es');
const { type: { TRADE_TOUR } } = TourStore;
const SV = require('server-vars');

// Styles
const styles = require('./shipping-styles.scss');

const DetailsShipping = props => {
    const {
        quotes,
        tradeTour,
        currency,
        context,
        copy,
        user,
        userId,
        hasUserId,
        itemIsSold,
        itemIsUnlisted,
        itemId,
        dealerPk,
        viewer,
        dealerData,
        item,
    } = props;
    const { estimateTitle: shippingTitle } = copy;
    const quoteRequestForAllIsEnabled = get(viewer, 'quoteRequestForAllIsEnabled');
    const isVerifiedTrade = get(user, 'canSeeTradeReturns', false);

    const hasQuote = filterQuotes(quotes.domestic).length || filterQuotes(quotes.local).length;
    const canRequest = hasUserId && (quoteRequestForAllIsEnabled || isVerifiedTrade);
    const linkQuoteCopy = hasQuote ? copy.hasQuote : copy.noQuote;

    const link = (
        <a className="pdp-shipping-link" href="#" data-tn="pdp-shipping-modal-link">
            {canRequest ? linkQuoteCopy.canRequest : linkQuoteCopy.cannotRequest}
        </a>
    );

    return (
        <div className="pdp-details-entry-content-container">
            <div className="pdp-details-entry-title-container">
                <Tour
                    step={4}
                    {...tradeTour}
                    dataTn="details-shipping-trade"
                    className={styles.shippingTitle}
                >
                    <div className="pdp-shipping-title">{shippingTitle}</div>
                </Tour>
            </div>
            <div className="pdp-shipping-entry">
                <QuotePrimary quotes={quotes} currency={currency} />
                <QuoteHandling quotes={quotes} currency={currency} />
                <QuoteSecondary quotes={quotes} currency={currency} />
            </div>
            {!itemIsSold &&
                !itemIsUnlisted && (
                    <div className="pdp-shipping-link-container">
                        <ShippingDetailsLink
                            parentName={'detailsShipping'}
                            pagePosition={'details-shipping'}
                            context={context}
                            user={user}
                            hasUserId={hasUserId}
                            userId={userId}
                            itemId={itemId}
                            dealerPk={dealerPk}
                            viewer={viewer}
                            quotes={quotes}
                            link={link}
                            regionType="DOMESTIC"
                            source={OPEN_DETAILS_FROM_DESCRIPTION}
                            dealerData={dealerData}
                            trackingLocation="pdp description"
                            item={item}
                        />
                    </div>
                )}
        </div>
    );
};

DetailsShipping.propTypes = {
    context: PropTypes.object,
    hidePrice: PropTypes.bool.isRequired,
    quotes: PropTypes.object.isRequired,
    user: PropTypes.object,
    userId: PropTypes.string,
    hasUserId: PropTypes.bool,
    itemIsSold: PropTypes.bool,
    itemIsUnlisted: PropTypes.bool,
    itemId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    currency: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    tradeTour: PropTypes.object.isRequired,
    dealerData: PropTypes.object,
    item: PropTypes.object,
};

module.exports = Relay.createContainer(
    provideContext(
        connectToStores(DetailsShipping, [ItemStore, PriceStore, TourStore, UserStore], context => {
            const userStore = context.getStore(UserStore);
            const itemStore = context.getStore(ItemStore);
            const item = itemStore.getItem();
            const priceStore = context.getStore(PriceStore);
            const { priceDisplays } = priceStore.processPrice(item);
            const tourStore = context.getStore(TourStore);
            return {
                hidePrice: itemStore.getHidePrice(),
                currency: userStore.getCurrency(),
                copy: itemStore.getCopy().shipping,
                tradeTour: {
                    type: TRADE_TOUR,
                    subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
                    copy: SV.get(`tourCopy.${TRADE_TOUR}`),
                    isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
                    currentStep: tourStore.getCurrentStep(TRADE_TOUR),
                    totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
                    onOpen: tourTracking.trackOpen,
                    onClose: tourTracking.trackClose,
                },
            };
        })
    ),
    {
        initialVariables: {
            hasUserId: false,
            itemId: null,
            userId: null,
        },
        fragments: {
            user: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on User {
                canSeeTradeReturns: hasPermission(name: "B_TRADE_RETURN_POLICY")
                ${ShippingDetailsLink.getFragment('user', { hasUserId, itemId, userId })}
            }
        `,
            item: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on Item {
                ${ShippingDetailsLink.getFragment('item', { hasUserId, itemId, userId })}
            }
        `,
            viewer: ({ hasUserId, itemId, userId }) => Relay.QL`
            fragment on Viewer {
                quoteRequestForAllIsEnabled: isEnabled(key: "enableRequestQuoteForAllLoggedIn")
                ${ShippingDetailsLink.getFragment('viewer', { hasUserId, itemId, userId })}
            }
        `,
        },
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsShipping.jsx